import { createI18n } from 'vue-i18n'
import config from './config'
/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */

import en from './locales/en'
import sv from './locales/sv'
import no from './locales/no'
import da from './locales/da'

import de from './locales/de'
import fr from './locales/fr'
import pl from './locales/pl'

function savedLocale() {
  return window.localStorage.getItem('selectedLocale') || config.defaultLanguage
}

// export default new VueI18n({
//   locale: process.env.VUE_APP_I18N_LOCALE || locale(),set
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: { en, sv }
// })

export default createI18n({
  legacy: true,
  locale: savedLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: { en, sv, no, da, de, fr, pl }
})
